export const adminPermission = {
  isAdmin: true,
};
